import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GridRequest, GridResponse, GridSettingsState } from '../grid/grid.model';

@Injectable({ providedIn: 'root' })
export class GridService {
  private readonly apiUrl = '/api/grid';
  private readonly exportUrl = '/api/grid/export';
  private readonly exportMethod = 'POST';
  private readonly storageKeyPrefix = 'app-grid-settings-';

  constructor(private http: HttpClient) {}

  getData(state: GridRequest): Observable<GridResponse> {
    return this.http.post<GridResponse>(this.apiUrl, state);
  }

  saveSettings(gridId: string, settings: GridSettingsState): void {
    localStorage.setItem(this.storageKeyPrefix + gridId, JSON.stringify(settings));
  }

  getSettings(gridId: string): GridSettingsState | null {
    const data = localStorage.getItem(this.storageKeyPrefix + gridId);
    return data ? JSON.parse(data) : null;
  }

  clearSettings(gridId: string): void {
    localStorage.removeItem(this.storageKeyPrefix + gridId);
  }

  sendAction(method: string, url: string, params: any): Observable<any>{
    return this.http.request(method, url, {
      body: params,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      responseType: 'text'
    }).pipe(
      map(response => {
        try {
          return JSON.parse(response);
        } catch (e) {
          return response;
        }
      })
    );
  }

  sendDownloadAction(method: string = 'POST', url: string = '/api/grid/export', params: any = {}): Observable<any>{
    return this.http.request(method, url, {
      body: params,
      observe: 'response', // i s hlavickou - content-disposition obsahuje nazev souboru
      responseType: 'blob'
    }).pipe(
      map(response => {
        return response;
      })
    );
  }
}